let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iAmtO")).then(() => parcelRequire('8iGYP'));